import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useTheme } from '@mui/material';
import { useSelector } from 'react-redux';

const useStyles = makeStyles((theme)=>({
    footerBlock:{
        marginTop:'70px',
        background:'#F7F7F7',
        height:'250px',

        fontFamily:[
            'Noto Sans KR'
        ],

        [theme.breakpoints.down(799)]: {
            height:'400px',
        }
        
    },
    row:{
        maxWidth:'1280px', 
        margin:'0 auto', 
        padding:'40px 0 0 0',

        [theme.breakpoints.down(799)]: {
            padding:'25px 0 0 0',
        }

    },
    footerContent:{
        display:'flex',
        justifyContent:'space-evenly',
        flexWrap: 'wrap',

    },
    topFlex:{
        display:'flex',
        justifyContent:'center',

        
    },
    left:{
        flexGrow:'0.1',
    },
    leftUl:{
        borderRight:'1px solid #CCC',
        [theme.breakpoints.down(358)]: {
            borderRight:'0',
            borderBottom:'1px solid #CCC',
            padding:'0 0 10px 0'
        }
    },
    leftBoldLi: props => ({
        color: props.palette.third.main,
        fontWeight:'bold',
        padding:'15px 0',
        fontSize:'18px',
    }),
    BoldLi:{
        fontWeight:'bold',
        padding:'15px 0 0 0',
        fontSize:'18px',
        letterSpacing:'-1.1px'
    },
    right:{
        flexGrow:'0.3',

        [theme.breakpoints.down(799)]: {
            paddingTop:'3%',
        }
    },
    rightUl:{
        borderLeft:'1px solid #CCCCCC',
        paddingLeft:'5%',

        [theme.breakpoints.down(799)]: {
            borderLeft:'none',
            borderTop:'1px solid #CCCCCC',
            paddingLeft:'none',
            paddingTop:'5%',
        }
    },
    rightBoldLi:{
        fontWeight:'bold',
        padding:'0 0 15px 0',
        fontSize:'18px',
    },
    rightSpan:{
        display:'block',
        paddingBottom:'3px',
        fontSize:'14px'
    },
    first:{
        fontSize:'18px'
    },
    last:{
        
    },
    
}));

const Footer = () => {
    const theme = useTheme();
    const classes = useStyles(theme);
    const shopInfo = useSelector(state => state.config.shopDefaultConfig)


    return(
        <div className={classes.footerBlock}>
            <div className={classes.row}>
                <div className={classes.footerContent}>
                    
                        <div className={classes.left}>
                            <ul className={classes.leftUl}>
                                <li className={classes.first}>
                                    CS CENTER
                                </li>
                                <li className={classes.leftBoldLi}>
                                    {shopInfo['de_admin_company_tel']} <br/>
                                    {shopInfo['de_sms_hp']}
                                </li>
                                <li className={classes.last}>
                                    AM 10:00 ~ PM 06:00 <br/>
                                    SAT, SUN, HOLIDAY OFF
                                </li>
                            </ul>
                        </div>
                        <div className={classes.middle}>
                            <ul>
                                <li className={classes.first}>
                                    BANK INFO
                                </li>
                                <li className={classes.BoldLi}>
                                    {shopInfo['de_bank_account'] && shopInfo['de_bank_account'].split(' ')[0]} <br/>
                                    {shopInfo['de_bank_account'] && shopInfo['de_bank_account'].split(' ')[1]} {shopInfo['de_bank_account'] && shopInfo['de_bank_account'].split(' ')[2].split(':')[1]}
                                </li>
                            </ul>
                        </div>
                    
                    <div className={classes.right}>
                        <ul className={classes.rightUl}>
                            <li className={classes.rightBoldLi}>
                                {shopInfo['de_admin_company_name']}
                            </li>
                            <li className={classes.last}>
                                <p>
                                    <span className={classes.rightSpan}>대표 : {shopInfo['de_admin_company_owner']} 개인정보 보호책임자 : {shopInfo['de_admin_info_name']} 사업자 등록번호 : {shopInfo['de_admin_company_saupja_no']}</span> 
                                    <span className={classes.rightSpan}>통신판매신고업번호 : {shopInfo['de_admin_tongsin_no']}</span> 
                                    <span className={classes.rightSpan}>주소 : {shopInfo['de_admin_company_addr']}</span> 
                                    <span className={classes.rightSpan}>전화 : {shopInfo['de_admin_company_tel']} 팩스 : {shopInfo['de_admin_company_fax']}</span> 
                                    <span className={classes.rightSpan}>Copyright &copy; 2022 {shopInfo['de_admin_company_owner']}. All Rights Reserved</span>
                                </p>
                            </li>                        
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Footer;